







import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import PageTitle from '@/components/common/PageTitle.vue';

@Component({
  components: { AdminIframe, PageTitle },
})
export default class PartnerEditPageIframe extends Vue {
  private remoteSrc = '';

  private setRemoteSrc() {
    const { query, params } = this.$route;
    const queryObject = { ...query, partnerNo: params.partnerNo, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();
    this.remoteSrc = process.env.VUE_APP_ADMIN_REMOTE_URL + '/configuration/partner/modification?' + queryString;
  }

  created() {
    this.setRemoteSrc();
  }
}
